define('v3/Common/Services/pageStateService',['jquery', 'knockout', 'lodash'], function ($, ko, _) {
	var queryStringVariables = {};
	var observables = {};

	var observableNumberConvertes = {};
	var observableStringConvertes = {};
	var observableBoolConvertes = {};

	var doNotUpdateHash = false;

	function getHash (e) {
		if (e && e.type === 'hashchange') {
			if (document.location.hash) {
				_.each(document.location.hash.substr(1).split('&'), function (q) {
					var i = q.split('=');
					queryStringVariables[decodeURIComponent(i[0])] = i[1] ? decodeURIComponent(i[1]).replace(/\+/g, ' ') : null;

					if (observables[decodeURIComponent(i[0])]) {
						observables[decodeURIComponent(i[0])](queryStringVariables[decodeURIComponent(i[0])]);
					}
				});
			}
		}

		if (e && e.type === 'popstate') {
			doNotUpdateHash = true;

			_.each(e.originalEvent.state, function (value, key) {
				if (observables[key.toLowerCase()]) {
					observables[key.toLowerCase()](value);
				}
			});
		}
	}

	getHash({ type: 'hashchange' });
	updateHash(true);
	$(window).on('popstate hashchange', getHash);

	function updateHash (isInitialLoad, changedKey) {
		var hashObject = _.reduce(queryStringVariables, function (result, value, key) {
			if (value) {
				result[key] = value.replace(/\+/g, '%20');
			}
			return result;
		}, {});
		var hash = $.param(hashObject, true);

		var commitState = 'replaceState';
		if (!isInitialLoad && observables[changedKey.toLowerCase()] && observables[changedKey.toLowerCase()].usePushState === true) {
			commitState = 'pushState';
		}

		history[commitState](hashObject, undefined, '#' + hash);
	}

	function getStorageKey (key) {
		return _(queryStringVariables).keys().find(function (k) {
			return k.toLowerCase() === key.toLowerCase();
		}) || key;
	}

	function removeObservable (key) {
		var storageKey = getStorageKey(key);
		delete queryStringVariables[storageKey];

		updateHash(false, key.toLowerCase());

		delete observables[key.toLowerCase()];
	}

	function getOrCreateObservable (key, options) {
		var observable = observables[key.toLowerCase()];

		if (!observable) {
			observables[key.toLowerCase()] = observable = ko.observable().extend({ deffer: true });
			observables[key.toLowerCase()].usePushState = options.usePushState || false;

			var storageKey = getStorageKey(key);

			observable.subscribe(function (value) {
				if (queryStringVariables[storageKey] !== value) {
					queryStringVariables[storageKey] = value;

					if (!doNotUpdateHash) {
						updateHash(false, key.toLowerCase());
					} else {
						doNotUpdateHash = false;
					}
				}
			});

			observable(queryStringVariables[storageKey]);
		}

		return observable;
	}

	function createObservableConverter (key, getValue, observableConverters, options) {
		var observable = getOrCreateObservable(key, options || {});

		observableConverters[key.toLowerCase()] = ko.computed({
			read: function () {
				return getValue(observable());
			},
			write: function (v) {
				if (v != null) {
					observable(v.toString());
				} else {
					observable(null);
				}
			}
		});
		return observableConverters[key.toLowerCase()];
	}

	return {
		getNumberObservable: function (key, options) {
			return observableNumberConvertes[key.toLowerCase()] || createObservableConverter(
				key,
				function (value) {
					if (value != null && !_.isNaN(+value)) {
						return +value;
					}
					return null;
				},
				observableNumberConvertes,
				options
			);
		},

		getStringObservable: function (key, options) {
			return observableStringConvertes[key.toLowerCase()] || createObservableConverter(
				key,
				function (value) { return value; },
				observableStringConvertes,
				options
			);
		},

		getBoolObservable: function (key, options) {
			return observableBoolConvertes[key.toLowerCase()] || createObservableConverter(
				key,
				function (value) { return value === 'true'; },
				observableBoolConvertes,
				options
			);
		},
		removeKey: function (key) {
			removeObservable(key);
		}

	};
});

